import styled from "styled-components";

// Nome do projeto entre o breadcrumb e as abas (18/08/2026).
export const ProjectName = styled.h1`
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.neutral.black};
`;

export const Wrapper = styled.div`
  margin: 0 auto;

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 700px;
  }
`;

export const Distributor = styled.div`
  padding: 10px;
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 10px;
`;
